import React, { ReactNode } from "react";
import { Button, Modal, FeaturedIcon } from "@myhealth-raccoon/components";

type Props = {
    isOpen: boolean,
    onClose(): void;
}

export function ConfirmClose({ isOpen, onClose }: Props): ReactNode {
    return <>
        <Modal
            open={isOpen}
            onClose={() => onClose()}
            hideX
        >
            <div className="p-1 mb-5">
                <FeaturedIcon size="lg" color="error" className="mb-2" />
                <h3 className="text-lg font-semibold text-gray-900">Are you sure you want to leave this booking?</h3>
                <p className="mt-1 font-base text-gray-600">
                    All selections will be lost
                </p>
            </div>
            <div className="p-1 flex justify-between gap-3 flex-wrap">
                <Button className="flex-1" color="gray" onClick={() => onClose()}>Cancel</Button>
                <Button className="flex-1" color="error" onClick={() => {
                    window.close();
                }}>Yes, Leave</Button>
            </div>
        </Modal>
    </>
}